import React, { useState } from "react";
import "./GoogleRecaptchaSettings.css";

export default function GoogleRecaptchaSettings() {
  const [formData, setFormData] = useState({
    siteKey: "",
    secretKey: "",
    status: "Disable",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form Submitted:", formData);
    // API call can go here
  };

  return (
    <div className="page-container">
      {/* Page Title + Breadcrumb */}
      <div className="page-header">
        <h2>Google reCaptcha Setting</h2>
        <div className="breadcrumb">
          <a href="/">Home</a> / <a href="/app-settings">App Settings</a> / Google reCaptcha Setting
        </div>
      </div>

      {/* Card */}
      <div className="card">
        <h3>Update Google reCaptcha</h3>

        <form onSubmit={handleSubmit}>
          <div className="form-grid">
            <div className="form-field">
              <label>Site Key</label>
              <input
                type="text"
                name="siteKey"
                value={formData.siteKey}
                onChange={handleChange}
              />
            </div>

            <div className="form-field">
              <label>Secret Key</label>
              <input
                type="text"
                name="secretKey"
                value={formData.secretKey}
                onChange={handleChange}
              />
            </div>

            <div className="form-field">
              <label>Enable / Disable Google Recaptcha</label>
              <select
                name="status"
                value={formData.status}
                onChange={handleChange}
              >
                <option value="Enable">Enable</option>
                <option value="Disable">Disable</option>
              </select>
            </div>
          </div>

          <div className="form-actions">
            <button type="submit" className="update-btn">
              Update
            </button>
          </div>
        </form>
      </div>

      {/* Footer */}
      <div className="footer">
        <p>
          Copyright © 2025 <span>Ample Markets</span>. All rights reserved.
        </p>
        <p className="version">Version 2.0</p>
      </div>
    </div>
  );
}

